import React from 'react';
import { NumericFormat } from 'react-number-format';
import { cn } from '../lib/utils';

/**
 * Money-formatted input with $ prefix and comma separators.
 * Stores value as plain number string (e.g., "100000") but displays as "$100,000".
 */
export function MoneyInput({ value, onChange, placeholder = '$0', className, testId, ...props }) {
  return (
    <NumericFormat
      value={value ?? ''}
      thousandSeparator=","
      prefix="$"
      decimalScale={2}
      allowNegative={false}
      placeholder={placeholder}
      onValueChange={(values) => {
        // values.value is the raw numeric string without prefix/commas
        onChange(values.value);
      }}
      className={cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      data-testid={testId}
      {...props}
    />
  );
}
